/* src/components/ProviderAwards/ProviderAwards.svelte generated by Svelte v3.48.0 */
import {
	SvelteComponent,
	add_flush_callback,
	append_hydration,
	attr,
	bind,
	binding_callbacks,
	check_outros,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert_hydration,
	listen,
	mount_component,
	safe_not_equal,
	set_data,
	space,
	src_url_equal,
	text,
	transition_in,
	transition_out
} from "svelte/internal";

import WidgetBuilder from '../WidgetBuilder/WidgetBuilder.svelte';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[8] = list[i];
	return child_ctx;
}

// (13:0) {#if awards && awards.length > 0}
function create_if_block(ctx) {
	let div;
	let t;
	let widgetbuilder;
	let updating_isModalOpen;
	let current;
	let each_value = /*awards*/ ctx[0];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	function widgetbuilder_isModalOpen_binding(value) {
		/*widgetbuilder_isModalOpen_binding*/ ctx[7](value);
	}

	let widgetbuilder_props = {
		id: /*providerId*/ ctx[2],
		permalink: /*permalink*/ ctx[1],
		providerName: /*providerName*/ ctx[3],
		selectedAward: /*selectedAward*/ ctx[4]
	};

	if (/*isModalOpen*/ ctx[5] !== void 0) {
		widgetbuilder_props.isModalOpen = /*isModalOpen*/ ctx[5];
	}

	widgetbuilder = new WidgetBuilder({ props: widgetbuilder_props });
	binding_callbacks.push(() => bind(widgetbuilder, 'isModalOpen', widgetbuilder_isModalOpen_binding));

	return {
		c() {
			div = element("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t = space();
			create_component(widgetbuilder.$$.fragment);
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(div_nodes);
			}

			div_nodes.forEach(detach);
			t = claim_space(nodes);
			claim_component(widgetbuilder.$$.fragment, nodes);
			this.h();
		},
		h() {
			attr(div, "class", "row justify-content-left awards svelte-153ke4l");
		},
		m(target, anchor) {
			insert_hydration(target, div, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(div, null);
			}

			insert_hydration(target, t, anchor);
			mount_component(widgetbuilder, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (dirty & /*isModalOpen, selectedAward, awards*/ 49) {
				each_value = /*awards*/ ctx[0];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(div, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			const widgetbuilder_changes = {};
			if (dirty & /*providerId*/ 4) widgetbuilder_changes.id = /*providerId*/ ctx[2];
			if (dirty & /*permalink*/ 2) widgetbuilder_changes.permalink = /*permalink*/ ctx[1];
			if (dirty & /*providerName*/ 8) widgetbuilder_changes.providerName = /*providerName*/ ctx[3];
			if (dirty & /*selectedAward*/ 16) widgetbuilder_changes.selectedAward = /*selectedAward*/ ctx[4];

			if (!updating_isModalOpen && dirty & /*isModalOpen*/ 32) {
				updating_isModalOpen = true;
				widgetbuilder_changes.isModalOpen = /*isModalOpen*/ ctx[5];
				add_flush_callback(() => updating_isModalOpen = false);
			}

			widgetbuilder.$set(widgetbuilder_changes);
		},
		i(local) {
			if (current) return;
			transition_in(widgetbuilder.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(widgetbuilder.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_each(each_blocks, detaching);
			if (detaching) detach(t);
			destroy_component(widgetbuilder, detaching);
		}
	};
}

// (15:4) {#each awards as award}
function create_each_block(ctx) {
	let div6;
	let div5;
	let div4;
	let img;
	let img_src_value;
	let img_alt_value;
	let t0;
	let div3;
	let div0;
	let t1_value = /*award*/ ctx[8].award + "";
	let t1;
	let t2;
	let div1;
	let t3_value = /*award*/ ctx[8].category + "";
	let t3;
	let t4;
	let div2;
	let t5;
	let t6;
	let mounted;
	let dispose;

	function click_handler() {
		return /*click_handler*/ ctx[6](/*award*/ ctx[8]);
	}

	return {
		c() {
			div6 = element("div");
			div5 = element("div");
			div4 = element("div");
			img = element("img");
			t0 = space();
			div3 = element("div");
			div0 = element("div");
			t1 = text(t1_value);
			t2 = space();
			div1 = element("div");
			t3 = text(t3_value);
			t4 = space();
			div2 = element("div");
			t5 = text("Claim Award");
			t6 = space();
			this.h();
		},
		l(nodes) {
			div6 = claim_element(nodes, "DIV", { class: true });
			var div6_nodes = children(div6);
			div5 = claim_element(div6_nodes, "DIV", { class: true });
			var div5_nodes = children(div5);
			div4 = claim_element(div5_nodes, "DIV", { class: true });
			var div4_nodes = children(div4);

			img = claim_element(div4_nodes, "IMG", {
				src: true,
				height: true,
				width: true,
				alt: true,
				class: true
			});

			t0 = claim_space(div4_nodes);
			div3 = claim_element(div4_nodes, "DIV", { class: true });
			var div3_nodes = children(div3);
			div0 = claim_element(div3_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			t1 = claim_text(div0_nodes, t1_value);
			div0_nodes.forEach(detach);
			t2 = claim_space(div3_nodes);
			div1 = claim_element(div3_nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			t3 = claim_text(div1_nodes, t3_value);
			div1_nodes.forEach(detach);
			t4 = claim_space(div3_nodes);
			div2 = claim_element(div3_nodes, "DIV", { class: true });
			var div2_nodes = children(div2);
			t5 = claim_text(div2_nodes, "Claim Award");
			div2_nodes.forEach(detach);
			div3_nodes.forEach(detach);
			div4_nodes.forEach(detach);
			div5_nodes.forEach(detach);
			t6 = claim_space(div6_nodes);
			div6_nodes.forEach(detach);
			this.h();
		},
		h() {
			if (!src_url_equal(img.src, img_src_value = "/awards/" + /*award*/ ctx[8].imageUri)) attr(img, "src", img_src_value);
			attr(img, "height", "115");
			attr(img, "width", "150");
			attr(img, "alt", img_alt_value = "Energy provider of the year for " + /*award*/ ctx[8].category);
			attr(img, "class", "award__img svelte-153ke4l");
			attr(div0, "class", "award__title svelte-153ke4l");
			attr(div1, "class", "award__category svelte-153ke4l");
			attr(div2, "class", "award__claim svelte-153ke4l");
			attr(div3, "class", "award__inner svelte-153ke4l");
			attr(div4, "class", "award__wrapper svelte-153ke4l");
			attr(div5, "class", "award svelte-153ke4l");
			attr(div6, "class", "col-md-4 mb-3");
		},
		m(target, anchor) {
			insert_hydration(target, div6, anchor);
			append_hydration(div6, div5);
			append_hydration(div5, div4);
			append_hydration(div4, img);
			append_hydration(div4, t0);
			append_hydration(div4, div3);
			append_hydration(div3, div0);
			append_hydration(div0, t1);
			append_hydration(div3, t2);
			append_hydration(div3, div1);
			append_hydration(div1, t3);
			append_hydration(div3, t4);
			append_hydration(div3, div2);
			append_hydration(div2, t5);
			append_hydration(div6, t6);

			if (!mounted) {
				dispose = listen(div2, "click", click_handler);
				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;

			if (dirty & /*awards*/ 1 && !src_url_equal(img.src, img_src_value = "/awards/" + /*award*/ ctx[8].imageUri)) {
				attr(img, "src", img_src_value);
			}

			if (dirty & /*awards*/ 1 && img_alt_value !== (img_alt_value = "Energy provider of the year for " + /*award*/ ctx[8].category)) {
				attr(img, "alt", img_alt_value);
			}

			if (dirty & /*awards*/ 1 && t1_value !== (t1_value = /*award*/ ctx[8].award + "")) set_data(t1, t1_value);
			if (dirty & /*awards*/ 1 && t3_value !== (t3_value = /*award*/ ctx[8].category + "")) set_data(t3, t3_value);
		},
		d(detaching) {
			if (detaching) detach(div6);
			mounted = false;
			dispose();
		}
	};
}

function create_fragment(ctx) {
	let if_block_anchor;
	let current;
	let if_block = /*awards*/ ctx[0] && /*awards*/ ctx[0].length > 0 && create_if_block(ctx);

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		l(nodes) {
			if (if_block) if_block.l(nodes);
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert_hydration(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			if (/*awards*/ ctx[0] && /*awards*/ ctx[0].length > 0) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*awards*/ 1) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { awards } = $$props;
	let { permalink } = $$props;
	let { providerId } = $$props;
	let { providerName } = $$props;
	let selectedAward;
	let isModalOpen = false;

	const click_handler = award => {
		$$invalidate(5, isModalOpen = true);
		$$invalidate(4, selectedAward = award.awardString);
	};

	function widgetbuilder_isModalOpen_binding(value) {
		isModalOpen = value;
		$$invalidate(5, isModalOpen);
	}

	$$self.$$set = $$props => {
		if ('awards' in $$props) $$invalidate(0, awards = $$props.awards);
		if ('permalink' in $$props) $$invalidate(1, permalink = $$props.permalink);
		if ('providerId' in $$props) $$invalidate(2, providerId = $$props.providerId);
		if ('providerName' in $$props) $$invalidate(3, providerName = $$props.providerName);
	};

	return [
		awards,
		permalink,
		providerId,
		providerName,
		selectedAward,
		isModalOpen,
		click_handler,
		widgetbuilder_isModalOpen_binding
	];
}

class ProviderAwards extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			awards: 0,
			permalink: 1,
			providerId: 2,
			providerName: 3
		});
	}
}

export default ProviderAwards;